import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import { ProgressSnackbarComponent } from '../shared/progress-snackbar/progress-snackbar.component';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {
  private progressSnackBarRef: MatSnackBarRef<ProgressSnackbarComponent> | null = null;
  private simpleSnackBarRef: MatSnackBarRef<SimpleSnackBar> | null = null;

  private progressSubject = new BehaviorSubject<{ message: string; progress: number }>({ 
    message: '', 
    progress: 0 
  });
  public progress$ = this.progressSubject.asObservable();

  constructor(private snackBar: MatSnackBar) {}

openProgressSnackbar(message: string, progress?: number) {

   if (this.progressSnackBarRef) {
      this.progressSnackBarRef.dismiss();
      this.progressSnackBarRef = null;
    }
    
    this.progressSnackBarRef = this.snackBar.openFromComponent(ProgressSnackbarComponent, {
      data: { 
        message, 
        progress: progress || 0,
        progress$: this.progress$  
      },
      horizontalPosition: 'right',
      verticalPosition: 'top',
      duration: undefined // ✅ Keep it open until manually closed
    });

    this.progressSubject.next({ message, progress: progress || 0 });
}

    updateProgress(progress: number, message?: string) {
      const currentData = this.progressSubject.value;
      this.progressSubject.next({ 
        message: message || currentData.message, 
        progress 
      });
  }


  closeProgressSnackbar() {
    if (this.progressSnackBarRef) {
      this.progressSnackBarRef.dismiss();
      this.progressSnackBarRef = null;
    }
    this.progressSubject.next({ message: '', progress: 0 });
  }

  openSnackbar(message: string, duration?: number, panelClass?: string) {
    if (!this.simpleSnackBarRef) {
      this.simpleSnackBarRef = this.snackBar.open(message, 'Close', {
        duration: undefined,
        horizontalPosition: 'right',
        verticalPosition: 'top',
        panelClass: [`snackbar-${panelClass || 'info'}`]
      });
    }
  }
  showError(message: string) {
    this.closeSnackbar();
    if (!this.simpleSnackBarRef) {
      this.simpleSnackBarRef = this.snackBar.open(message, 'Close', {
        duration: undefined,
        horizontalPosition: 'right',
        verticalPosition: 'top',
        panelClass: [`snackbar-error`]
      });
    }
  }

    closeSnackbar() {
    if (this.simpleSnackBarRef) {
      this.simpleSnackBarRef.dismiss();
      this.simpleSnackBarRef = null;
    }
  }

}